import { Outlet } from 'react-router';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileBottomNav } from './MobileBottomNav';
import { useUrlHydration } from '@/hooks/useUrlHydration';
import { useCart } from '@/hooks/useCart';
import { ToastContainer } from '@/components/ui/Toast';
import { OfflineBanner } from '@/components/ui/OfflineBanner';
import { useToastStore } from '@/stores/useToastStore';
import { useCookieConsentBanner } from '@/contexts/CookieConsentContext';
import { cn } from '@/lib/utils';

export const Layout = () => {
    useUrlHydration();
    // Hydrate cart from backend on app load (backend is source of truth)
    // This hook fetches cart from API and syncs to Zustand store
    useCart();
    const { toasts, removeToast } = useToastStore();
    const { isBannerVisible } = useCookieConsentBanner();

    return (
        <div className="flex min-h-screen flex-col">
            {/* Sitewide JSON-LD (Organization + WebSite) now ships from the root
                route's `meta` export — see `app/root.tsx`. */}

            {/* Offline Banner - appears when user loses connectivity */}
            <OfflineBanner />
            {/* Skip to main content link for keyboard users */}
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg"
            >
                Skip to main content
            </a>
            <Header />
            {/* pb-16 reserves space for the mobile bottom nav; removed on lg+ */}
            {/* pb-32/sm:pb-24 reserves additional room when the cookie banner is visible */}
            <main
                id="main-content"
                className={cn(
                    'flex-grow pb-16 lg:pb-0',
                    isBannerVisible && 'pb-32 sm:pb-24',
                )}
                tabIndex={-1}
            >
                <Outlet />
            </main>
            <Footer />

            {/* Mobile bottom navigation — hidden on desktop */}
            <MobileBottomNav />

            {/* Accessible Toast Notifications */}
            <ToastContainer toasts={toasts} onDismiss={removeToast} />
        </div>
    );
};
